import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
    const handleLinkClick = () => {
        const navbarCollapse = document.getElementById('collapsenavbar');
        if (navbarCollapse) {
            navbarCollapse.classList.remove('show'); // Hide the navbar options
        }
    };
    return (
        <div>
            <nav className="navbar navbar-expand-sm bg-warning navbar-dark fixed-top">
                <div className="container" >
                    <a href="/" className="navbar-brand">
                        <img src={require('../assets/img/disneyland.png')} alt="image" class="dianeyland" id="disnayland123"/>
                    </a>

                    <button id="toggler"
                        type="button"
                        className="navbar-toggler"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsenavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div id="collapsenavbar" className="collapse navbar-collapse">
                        <div className="navbar-nav">
                            <Link to={'/'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn2">Home</button>
                            </Link>
                            <Link to={'/museum'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn3">Parks and Tickets</button>
                            </Link>
                            <Link to={'/store'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn4">Places To Stay</button>
                            </Link>
                            <Link to={'/chefs'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn5">Things To Do</button>
                            </Link>
                            <Link to={'/special'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn6">Special Offer</button>
                            </Link>
                            <Link to={'/contact'} onClick={handleLinkClick}>
                                <button className='bg-info' id="btn1" class="btn7">Contact</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
            <br />
            <br />
        </div>
    );
}